import { render, staticRenderFns } from "./TsNftWidgetShare.vue?vue&type=template&id=021723b6&scoped=true&"
import script from "./TsNftWidgetShare.vue?vue&type=script&lang=js&"
export * from "./TsNftWidgetShare.vue?vue&type=script&lang=js&"
import style0 from "./TsNftWidgetShare.vue?vue&type=style&index=0&id=021723b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021723b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VContainer,VIcon,VImg,VSheet,VSkeletonLoader,VSubheader})
